import { render } from "./UserRegister.vue?vue&type=template&id=50661780&scoped=true&ts=true"
import script from "./UserRegister.vue?vue&type=script&lang=ts"
export * from "./UserRegister.vue?vue&type=script&lang=ts"

import "./UserRegister.vue?vue&type=style&index=0&id=50661780&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50661780"]])

export default __exports__